<div class="flex flex-col justify-between h-full">
  <!-- Form Content -->
  <div class="p-6" [formGroup]="form">
    <div class="flex flex-col gap-4">
      <!-- Left Column -->
      <div class="flex flex-col gap-6">
        <app-form-card title="Booking Details" icon="Calendar">
          <app-form-field label="Booked On">
            <app-date-picker
              formControlName="bookedAt"
              placeholder="Select Date"
            ></app-date-picker>
          </app-form-field>
        </app-form-card>

        <app-form-card title="Who did you book the load with?" icon="Users">
          <app-radio-card-group
            formControlName="partyType"
            [options]="partyTypeOptions"
          ></app-radio-card-group>
        </app-form-card>

        @if (partyType(); as party) {
        <div class="animate-fade-in">
          @switch (party) { @case ('broker') {
          <app-form-card
            title="Broker Details"
            icon="Briefcase"
            formGroupName="broker"
          >
            <div class="grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2">
              <div class="sm:col-span-2">
                @if (extractedBrokerName() && !form.get('broker.brokerCompany')?.value) {
                <app-text variant="muted" size="sm" class="mb-1 block italic">Extracted from document: {{ extractedBrokerName() }}</app-text>
                }
                <app-form-field label="Broker Company">
                  <app-partner-search
                    formControlName="brokerCompany"
                    [filterByType]="'broker'"
                    placeholder="Search your broker partners..."
                    (addNewPartner)="openAddPartnerModal()"
                  ></app-partner-search>
                </app-form-field>
              </div>
              <app-form-field label="Broker Load ID">
                <app-input
                  formControlName="brokerLoadId"
                  placeholder="e.g., TQL-98765"
                ></app-input>
              </app-form-field>
              <app-form-field label="Your Rate">
                <app-number-input
                  formControlName="brokerBookedAtRate"
                  currency="USD"
                ></app-number-input>
              </app-form-field>
            </div>
          </app-form-card>
          } @case ('customer') {
          <app-form-card
            title="Customer Details"
            icon="UserRound"
            formGroupName="customer"
          >
            <div class="grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2">
              <div class="sm:col-span-2">
                @if (extractedCustomerName() && !form.get('customer.customerCompany')?.value) {
                <app-text variant="muted" size="sm" class="mb-1 block italic">Extracted from document: {{ extractedCustomerName() }}</app-text>
                }
                <app-form-field label="Customer Company">
                  <app-partner-search
                    formControlName="customerCompany"
                    [filterByType]="'customer'"
                    placeholder="Search your customer partners..."
                    (addNewPartner)="openAddPartnerModal()"
                  ></app-partner-search>
                </app-form-field>
              </div>
              <app-form-field label="Customer Load ID">
                <app-input
                  formControlName="customerLoadId"
                  placeholder="e.g., PO-98765"
                ></app-input>
              </app-form-field>
              <app-form-field label="Load Rate">
                <app-number-input
                  formControlName="customerBookedAtRate"
                  currency="USD"
                ></app-number-input>
              </app-form-field>
            </div>
          </app-form-card>
          } @case ('carrier') {
          <app-form-card
            title="Forwarded From Details"
            icon="Truck"
            formGroupName="carrier"
          >
            <div class="grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2">
              <div class="sm:col-span-2">
                @if (extractedCarrierName() && !form.get('carrier.carrierCompany')?.value) {
                <app-text variant="muted" size="sm" class="mb-1 block italic">Extracted from document: {{ extractedCarrierName() }}</app-text>
                }
                <app-form-field label="Carrier Company">
                  <app-partner-search
                    formControlName="carrierCompany"
                    [filterByType]="'carrier'"
                    placeholder="Search your carrier partners..."
                    (addNewPartner)="openAddPartnerModal()"
                  ></app-partner-search>
                </app-form-field>
              </div>
              <app-form-field label="Carrier Load ID">
                <app-input
                  formControlName="carrierLoadId"
                  placeholder="e.g., CR-98765"
                ></app-input>
              </app-form-field>
              <app-form-field label="Load Rate">
                <app-number-input
                  formControlName="carrierBookedAtRate"
                  currency="USD"
                ></app-number-input>
              </app-form-field>

              <!-- Optional Original Broker Section -->
              <div class="sm:col-span-2 mt-2 pt-3 border-t border-border">
                <div class="mb-2">
                  <app-text variant="foreground" weight="medium" size="sm">Original Freight Broker</app-text>
                  <app-text variant="muted" size="xs">Optional: If forwarded by this carrier, select the broker who originated the load.</app-text>
                </div>
                @if (extractedBrokerName() && !form.get('carrier.brokerCompany')?.value) {
                <app-text variant="muted" size="sm" class="mb-1 block italic">Extracted from document: {{ extractedBrokerName() }}</app-text>
                }
                <app-form-field label="Original Broker (Optional)">
                  <app-partner-search
                    formControlName="brokerCompany"
                    [filterByType]="'broker'"
                    placeholder="Search your broker partners..."
                    (addNewPartner)="openAddPartnerModal('broker')"
                  ></app-partner-search>
                </app-form-field>
              </div>
              <div class="sm:col-span-2">
                <app-form-field label="Original Broker Load ID (Optional)">
                  <app-input
                    formControlName="brokerLoadId"
                    placeholder="e.g., AB-98765"
                  ></app-input>
                </app-form-field>
              </div>
            </div>
          </app-form-card>
          }
          }
        </div>
        }
      </div>

      <!-- Right Column -->
      <div class="flex flex-col gap-6">
        <app-form-card title="Who is hauling this load?" icon="Truck">
          <app-radio-card-group
            formControlName="haulingType"
            [options]="haulingTypeOptions"
            gridClass="grid-cols-1 sm:grid-cols-3"
          ></app-radio-card-group>
        </app-form-card>
        @if (forwarded()) {
        <div class="animate-fade-in">
          <app-form-card
            title="{{
              haulingType() === 'ownerOperator'
                ? 'Owner-Operator Details'
                : 'Carrier Details'
            }}"
            icon="Send"
            formGroupName="forwarding"
          >
            <div class="grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2">
              <app-form-field
                label="{{
                  haulingType() === 'forwarding'
                    ? 'Carrier'
                    : 'Owner Operator'
                }}"
                class="sm:col-span-2"
              >
                <app-company-search
                  formControlName="hauledByCompany"
                  placeholder="Search by name, DOT, or MC..."
                ></app-company-search>
              </app-form-field>
              <app-form-field
                label="{{
                  haulingType() === 'forwarding'
                    ? 'Carrier\'s Rate'
                    : 'Owner-Operator\'s Rate'
                }}"
              >
                <app-number-input
                  formControlName="forwardRate"
                  currency="USD"
                ></app-number-input>
              </app-form-field>

            </div>
          </app-form-card>
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Modal Actions -->
  <div
    class="flex flex-col-reverse lg:flex-row justify-end gap-3 p-2 md:p-4 border-t border-border"
  >
    <app-button variant="secondary" (click)="cancel()" [disabled]="isSaving()">
      Cancel
    </app-button>
    <app-button
      (click)="save()"
      [disabled]="form.invalid || isSaving()"
      [loading]="isSaving()"
    >
      {{ isSaving() ? "Saving..." : "Save Changes" }}
    </app-button>
  </div>
</div>
